import React from "react";

const Contact = () => {
  return (
    <section id="contact">
      <h2>Contact Us</h2>

      <p>
        Have a project in mind or need a reliable IT partner?  
        Get in touch with us today.
      </p>

      <p>
        📧 Email: <strong>info@infobizz.com</strong>
      </p>
      <p>
        🌐 Website: <strong>www.infobizz.website</strong>
      </p>
    </section>
  );
};

export default Contact;
